<template>
  <div class="score-entry">
    <el-dialog title="实践活动成绩录入" :visible.sync="scoreEntryShow" width="50%" :before-close="dialogClose"
      @open="dialogOpen">
      <div class="btn-list" v-show="isChooseContainerShow">
        <el-button type="primary" @click="scoreEntryStudent">单个学生录入</el-button>
        <el-button type="primary" @click="scoreEntryClass">批量录入(班级)</el-button>
        <el-button type="primary" @click="scoreEntryGrade">批量录入(年级)</el-button>
      </div>
      <!-- 上传成绩方式选择 -->
      <div v-show="!isChooseContainerShow">
        <!-- 单个学生录入 -->
        <scoreEntryStudent ref="scoreEntryStudent" :isChooseContainerShow.sync="isChooseContainerShow"
          :gradeStudentList="gradeStudentList" :activityData="activityData" v-show="addMode == 'student'"
          @scoreEntryStudentSubmit="scoreEntryStudentSubmit" />
        <!-- 班级录入 -->
        <scoreEntryClass :isChooseContainerShow.sync="isChooseContainerShow" :className="className"
          :classPlaceholder="classPlaceholder" :classProps="classProps" :classSelect="classSelect"
          :activityData="activityData" v-show="addMode == 'class'" @uploadClassSuccess="uploadSuccess" />
        <!-- 年级录入 -->
        <scoreEntryGrade :isChooseContainerShow.sync="isChooseContainerShow" :classSelectList="classSelectList"
          :activityData="activityData" v-show="addMode == 'grade'" @uploadGradeSuccess="uploadSuccess" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import scoreEntryStudent from "../score-entry-student/scoreEntryStudent.vue";
import scoreEntryClass from "../score-entry-class/scoreEntryClass.vue";
import scoreEntryGrade from "../score-entry-grade/scoreEntryGrade.vue";
export default {
  props: [
    "scoreEntryShow",
    "className",
    "classPlaceholder",
    "classProps",
    "classSelect",
    "classSelectList",
    "gradeStudentList",
    "activityData",
  ],
  components: {
    scoreEntryStudent,
    scoreEntryClass,
    scoreEntryGrade,
  },
  data() {
    return {
      addMode: "", // 录入方式
      isChooseContainerShow: true, // 为true时显示考试信息，为false根据addMode的值显示两种上传方式的一种
    };
  },
  inject: ["refresh"],
  methods: {
    dialogOpen() {
      this.addMode = "";
      this.isChooseContainerShow = true;
      // 重置选择学生内容
      setTimeout(() => {
        this.$refs.scoreEntryStudent.selectStudent = "";
        this.$refs.scoreEntryStudent.activityFullList = [
          {
            activityName: "篮球比赛",
            hours: "", // 学时
            credit: "", // 学分
            evaluationLevel: "", // 评定等级
          },
        ];
      }, 500);
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:scoreEntryShow", false);
    },
    // 选择单个学生录入
    scoreEntryStudent() {
      this.isChooseContainerShow = false;
      this.addMode = "student";
    },
    // 单个学生成绩录入点击提交
    scoreEntryStudentSubmit(data) {
      this.post(this.$url.addPracticeRecord, data).then((res) => {
        // console.log("单个学生录入实践记录：", res);
        if (res.code !== 200) return this.$message.error(res.msg || "录入失败");
        this.$message.success(res.msg || "录入成功");
        this.refresh();
        this.$emit("update:scoreEntryShow", false);
      });
    },
    // 选择班级成绩录入
    scoreEntryClass() {
      this.isChooseContainerShow = false;
      this.addMode = "class";
    },
    // 班级年级成绩录入成功
    uploadSuccess() {
      this.$emit("update:scoreEntryShow", false);
      this.refresh();
    },
    // 选择年级成绩录入
    scoreEntryGrade() {
      this.isChooseContainerShow = false;
      this.addMode = "grade";
    },
    // 年级成绩录入点击提交
    scoreEntryGradeSubmit(e) { },
  },
};
</script>

<style lang="scss" scoped>
@import "./scoreEntryDialog.scss";
</style>